import api, { apiAction, apiActionWithRoute } from '../../../api'

export const fetchItems = () => apiAction(api.getUsers)()
export const addItem = item => apiAction(api.addUser)(item)
export const deleteItem = entityId => apiActionWithRoute(api.deleteUser)(entityId)()
export const updateItem = (entityId, item) => apiActionWithRoute(api.updateUser)(entityId)(item)
